import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { removeErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import { sortObjectArray } from '../../../main/functions/sortObjectArray';

interface ValidierungHinweiseProps extends React.ClassAttributes<any> {
    data?: any;
    entities: any;
    iconColor?: string;
    id: number | string;
    layout2?: boolean;
    layout3?: boolean;
    showPriorityColors?: boolean;
    style?: React.CSSProperties;
    validation: any;
}

interface ValidierungHinweiseState {
    mouseOverHinweise: number | string;
}

export class ValidierungHinweise extends React.Component<ValidierungHinweiseProps, ValidierungHinweiseState> {

    constructor(props: any) {
        super(props);
        this.state = {
            mouseOverHinweise: undefined
        };
    }

    private priorities: any = {
        error: { color: 'red' },
        warning: { color: '#616468' },
        info: { color: '#354f84' },
        success: { color: '#00aa00' }
    };

    getSortedTids(data: string[], entity: string): string[] {
        const entities: string[] = [IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME, IDs.ENT_ENERGIEDATEN_WASSER];

        if (this.props.data && entities.indexOf(entity) !== -1) {
            const dataSorted: any[] = [];
            const dataYear: any[] = ((this.props.data || {})[entity] || [])
                .filter((item: any) => (data || []).indexOf((item.tid || '').toString()) !== -1);
            const zaehler: any[] = ((this.props.data || {})[IDs.ENT_ZAEHLER] || []).filter((item: any) =>
                dataYear.find((item2: any) => item2.zaehler_tid_orig === item.tid)
            );
            sortObjectArray(zaehler, ['zaehlernummer']);

            zaehler.forEach((item: any) => {
                while (dataYear.find((item2: any) => item2.zaehler_tid_orig === item.tid)) {
                    const index: number = dataYear.findIndex((item3: any) => item3.zaehler_tid_orig === item.tid);

                    if (index !== -1) {
                        dataSorted.push(dataYear[index]);
                        dataYear.splice(index, 1);
                    }
                }
            });
            return [...dataSorted, ...dataYear].map((item: any) => item.tid);
        }

        return data;
    }

    render(): JSX.Element {
        const id: number | string = this.props.id || null;
        const priorities: any[] = Object.keys(this.priorities);
        const validation: any = (this.props.validation || {})[id] || {};
        let hinweise: number = 0;
        let priority: number = null;

        Object.keys(validation).forEach((entity: string) => {
            hinweise += Object.keys(validation[entity]).reduce((anzahl: number, tid: string) =>
                anzahl + Object.keys(validation[entity][tid]).reduce(
                    (anzahl2: number, field: string) => {
                        const data: any = validation[entity][tid][field] || {};
                        const type: string = data.type || null;
                        const indexType: number = Object.keys(this.priorities).indexOf(type);
                        priority = indexType !== -1 && (priority === null || (indexType < priority)) ? indexType : priority;
                        return anzahl2 + (Object.keys(data).length === 0 ? 0 : (data.text || []).length);
                    }, 0
                ), 0
            );
        });
        const color: string = this.props.showPriorityColors
            ? (this.priorities[priorities[priority] || null] || {}).color || this.props.iconColor || 'black'
            : this.props.iconColor || 'black';

        switch (true) {
            case !hinweise:
                return null;
            case this.props.layout2:
                return this.renderLayout2(color, hinweise);
            case this.props.layout3:
                return this.renderLayout3();
            default:
                return this.renderLayout(color);
        }
    }

    renderHinweise(id: number | string): JSX.Element {
        const validation: any = (this.props.validation || {})[id] || {};
        const elements: JSX.Element[] = [];
        let hasErrors: boolean = false;
        let hasWarnings: boolean = false;

        Object.keys(validation).forEach((entity: string, index: number) => {
            const titel: any = this.props.entities && Array.isArray(this.props.entities)
                ? (this.props.entities.find((item: any) => (item.entity || null) === entity) || {}).titel || null
                : null;
            const values: any = {};
            let suffix: string = null;

            this.getSortedTids(Object.keys(validation[entity]), entity).forEach((tid: string) => {
                Object.keys(validation[entity][tid]).forEach((field: string) => {
                    const category: string = (validation[entity][tid][field] || {}).category || null;
                    const type: string = (validation[entity][tid][field] || {}).type || null;
                    const text: string[] = (validation[entity][tid][field] || {}).text || [];
                    hasErrors = type === 'error' ? true : hasErrors;
                    hasWarnings = type === 'warning' ? true : hasWarnings;
                    suffix = category === 'compare_prev' && suffix === null
                        ? ` - ${i18n('Im Vergleich zum Vorjahr', 'sys')}`
                        : (type && category !== 'compare_prev' ? '' : suffix);

                    text.forEach((value: string) => {
                        if (typeof value !== 'string') {
                            return;
                        }

                        if (typeof values[value] === 'undefined') {
                            values[value] = { count: 0, ...(category && { category }), ...(type && { type }) };
                        }
                        ++values[value].count;
                    });
                });
            });

            if (Object.keys(values).length) {
                elements.push(
                    <React.Fragment key={`entity-${index}`}>
                        {titel && <b>{titel}</b>}{suffix && <>{suffix}</>}
                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                            {Object.keys(values).map((value: string, index2: number) => {
                                const data: any = values[value] || {};
                                const count: number = data.count || 0;
                                const type: string = data.type || null;
                                const color: string = (this.priorities[type] || {}).color || 'black';
                                const info = removeErrorLevelAddOn(value);
                                return (
                                    <li key={`value-${index2}`} style={{ ...(this.props.showPriorityColors ? { color } : {}) }}>
                                        {info}{count > 1 ? ` (${count})` : ''}
                                    </li>
                                );
                            })}
                        </ul>
                    </React.Fragment>
                );
            }
        });

        if (!elements.length) {
            return null;
        }
        const styleBorder: React.CSSProperties = !this.props.layout3 ? { border: '1px solid black' } : {};
        const styleWidth: React.CSSProperties = !this.props.layout2 && !this.props.layout3 ? { width: 320 } : {};
        const styleMaxWidth: React.CSSProperties = !this.props.layout3 ? { maxWidth: 320 } : {};
        const stylePosition: React.CSSProperties = this.props.layout2
            ? { position: 'absolute' }
            : (!this.props.layout3 ? { position: 'relative' } : {});

        return (
            <div
                style={{
                    fontSize: 12, fontStyle: 'normal', fontWeight: 'normal', color: 'black', textAlign: 'left',
                    backgroundColor: '#e5e4e4', ...styleWidth, ...styleMaxWidth, padding: 5,
                    ...styleBorder, ...stylePosition, zIndex: 1
                }}
            >
                {elements}
                {(hasErrors || hasWarnings) &&
                    this.renderErlaeuterung(hasErrors, hasWarnings)
                }
            </div>
        );
    }

    renderErlaeuterung(hasErrors: boolean, hasWarnings: boolean): JSX.Element {
        return (
            <div style={{ fontSize: 'smaller', marginTop: 5, paddingTop: 5, borderTop: '1px solid black' }}>
                <b>{i18n('Erläuterung', 'sys')}</b>:
                <ul style={{ margin: '5px 0 0 0', paddingLeft: 16 }}>
                    {hasWarnings &&
                        <li>{this.renderErlaeuterungWarnings()}</li>
                    }
                    {hasErrors &&
                        <li>{this.renderErlaeuterungErrors()}</li>
                    }
                </ul>
            </div>
        );
    }

    renderIcon(color: string): JSX.Element {
        return (
            <svg height={14} style={{ overflow: 'visible' }} viewBox='0 0 1886 1717'>
                <path
                    style={{ fill: color }}
                    d='M924,2c136.56-.854,162.38,73.6,212,158q39.99,70.994,80,142,275.475,487.952,551,976,32.49,58.995,65,118c16.37,27.85,35.79,55.62,46,89,29.49,96.4-30.4,173.18-86,206-47.89,28.27-125.54,24-203,24H230c-33.442,0-71.478,2.81-98-5-50.14-14.76-85.032-46.04-109-87-19.287-32.96-28.425-95.15-14-141,13.38-42.52,40.582-79.68,62-116q46-82.995,92-166L633,368,758,146c22.449-38.123,38.8-80.78,73-107A195.67,195.67,0,0,1,892,8Zm18,179Q560.538,858.933,179,1537H1707q-273.975-485.955-548-972-77.985-138.486-156-277C990.4,266.614,957.6,192.178,942,181Zm-2,478c73.09,1.208,118.15,44.392,129,108,5.49,32.182-4.92,64.9-10,91q-10.5,69.493-21,139c-15.64,80.32-4.64,170.89-87,185-95.869,16.42-89.689-114.24-103-185L828,864c-5.373-27.966-15.615-63.551-9-97a154.323,154.323,0,0,1,31-67c14.173-17.894,39.522-31.759,65-38Zm-4,587c97.18-2.18,103,126.87,19,143-55.6,10.68-99.323-48.6-79-98C887.652,1262.68,906.979,1257.7,936,1246Z'
                />
            </svg>
        );
    }

    renderErlaeuterungErrors(): JSX.Element {
        return (
            <div>
                In <span style={{ fontWeight: 'bold', color: this.priorities.error.color }}>rot dargestellte Meldungen</span> wertet das
                E-Tool als nicht plausibel/falsch. Sie werden daher in der Datenauswertung nicht berücksichtigt.
            </div>
        );
    }

    renderErlaeuterungWarnings(): JSX.Element {
        return (
            <div>
                In <span style={{ fontWeight: 'bold', color: this.priorities.warning.color }}>grau dargestellte Meldungen</span> sind nur
                als Hinweis(e) zu verstehen (nochmalige Prüfung empfohlen); sie haben keine Auswirkung auf die Datenauswertung.
            </div>
        );
    }

    renderLayout(color: string): JSX.Element {
        const id: number | string = this.props.id || null;

        return (
            <div
                style={{
                    width: 18, height: 14, left: '100%', marginTop: -15, marginLeft: -20, display: 'flex', position: 'relative',
                    ...(this.props.style || {})
                }}
                onMouseEnter={() => this.setState({ mouseOverHinweise: id })}
                onMouseLeave={() => this.setState({ mouseOverHinweise: undefined })}
            >
                {this.renderIcon(color)}
                <div style={{ marginLeft: 4, marginTop: 14 }}>
                    {(this.state.mouseOverHinweise || null) === id &&
                        this.renderHinweise(id)
                    }
                </div>
            </div>
        );
    }

    renderLayout2(color: string, hinweise: number): JSX.Element {
        const id: number | string = this.props.id || null;
        const styleColor: React.CSSProperties = this.props.showPriorityColors ? { color } : {};

        return (
            <div
                style={{ display: 'flex', marginRight: 9, alignItems: 'flex-end', ...styleColor, ...(this.props.style || {}) }}
                onMouseEnter={() => this.setState({ mouseOverHinweise: id })}
                onMouseLeave={() => this.setState({ mouseOverHinweise: undefined })}
            >
                <span style={{ fontSize: 12, fontWeight: 'bold', marginRight: 5 }}>
                    {hinweise}
                </span>
                {this.renderIcon(color)}
                {(this.state.mouseOverHinweise || null) === id &&
                    <div>{this.renderHinweise(id)}</div>
                }
            </div>
        );
    }

    renderLayout3(): JSX.Element {
        const id: number | string = this.props.id || null;

        return (
            <div style={this.props.style}>
                <div>{this.renderHinweise(id)}</div>
            </div>
        );
    }
}
